import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate , useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import Home from "./component/Outerpage/Home";
import About from "./component/Outerpage/About";
import GenerateCodePage from "./component/Outerpage/Generatecode";
import VerifyAndResetPage from "./component/Outerpage/VerifyAndResetPage";
import Editpage from "./component/Innerpages/Editpage";
import Profile from "./component/Innerpages/Profile";
import OTP from "./component/Outerpage/OTP";
import OrdersPage from "./component/Innerpages/Orderpage";
import Header from "./subcomponents/header";
import CompleteProfile from "./component/Outerpage/CompleteProfile";
import Dashboard from "./component/Innerpages/Dashboard";
import Levels from "./component/Innerpages/Levels";
import Select from "./component/Innerpages/Select";
import Sellerproductpage from ".//component/Innerpages/Selectproduct"
import Connect from "./component/Innerpages/Connect";
import ConnectProduct from "./component/Innerpages/Coonectproduct"
import Viewshop from "./component/Innerpages/Viewshop";
import Viewshoprider from "./component/Innerpages/Viewshoprider";
import Createaorderpage from "./component/Innerpages/Createaorderpage";
import CompleteprofileSeller from "./component/Outerpage/CompleteprofileSeller";
import SellerLevels from "./component/Innerpages/LevelsSellers";
import RiderLevels from "./component/Innerpages/Levelsriders";
import PaymentPage from "./component/Innerpages/Paymentpage";
import Auth from "./component/Outerpage/Auth";
import Sellersorder from "./component/Innerpages/Sellersorder";
import Ridersorder from "./component/Innerpages/Ridersorder";
import Trackorderpage from "./component/Innerpages/Trackorderpage";
import Innertrack from "./component/Innerpages/Innertrack";
import Contactus from "./component/Outerpage/Contactus";
import Balancepage from "./component/Innerpages/Balancepage";
import Fundwallet from "./component/Innerpages/Fundwallet";
import Withdrawpage from "./component/Innerpages/Withdrawpage";
import Confirmationpage from "./component/Innerpages/Confirmationpage";
import Historypage from "./component/Innerpages/Historypage";
import Addbankdetails from "./component/Innerpages/Addbankdetails";
import Notification from "./component/Innerpages/Notification";
import Sellerprofile from "./component/Innerpages/Sellerprofile";
import Sellereditprofile from "./component/Innerpages/Sellereditprofile";
import Viewreviwspage from "./component/Innerpages/Viewreviwspage";
import Admindashboard from "./component/Innerpages/Admindashboard";
import Adminalluser from "./component/Innerpages/Adminalluser";
import Adminorders from "./component/Innerpages/Adminorders";
import AdminPayments from "./component/Innerpages/Adminpayments";
import Adminnoti from "./component/Innerpages/Adminnoti";
import Conversation from "./component/Innerpages/Conversation";
import Messenger from "./component/Innerpages/Messenger";
import Nopagefound from "./component/Innerpages/Nopagefound";
import Adminmessages from "./component/Innerpages/Adminmessages";
import Termsandcondition from "./component/Outerpage/Termsandcondition";
import Privacypolicy from "./component/Outerpage/Privacypolicy";
import FAQ from "./component/Outerpage/FAQ";
import CompleteRiderpage from "./component/Outerpage/CompleteRiderpage";
import Connectrider from "./component/Innerpages/Connectrider";
import Feedback from "./component/Innerpages/Feedback";
import Adminrider from "./component/Innerpages/Admiacceptrider";
import Sellproduct from "./component/Outerpage/Sellproduct";
import Congratulationpage from "./component/Outerpage/Congratulationpage";
import ProductSellPage from "./component/Innerpages/Produxtsellpage";
import Editproduct from "./component/Outerpage/Editproduct";
import Bookmarkpage from "./component/Outerpage/Bookmarkpage";
import Charegpage from "./component/Outerpage/Charegpage";
import Viewproduct from "./component/Innerpages/Viewproduct";
import Settings from "./component/Innerpages/Settings";
import Blockeduser from "./component/Innerpages/Blockeduser";
import Blockedproduct from "./component/Innerpages/Blockedproduct";
import Cotract from "./component/Outerpage/Cotract";
import CongratContract from "./component/Outerpage/CongratContract";
import Contractpayment from "./component/Outerpage/Contractpayment";
import Reviewcontract from "./component/Outerpage/Reviewcontract";
import ReviewContract from "./component/Outerpage/Reviewcontract";
import Mycontract from "./component/Outerpage/Mycontract";
import Statecontract from "./component/Outerpage/Statecontract";
import Othercontract from "./component/Outerpage/Othercontract";
import Otherstate from "./component/Outerpage/Otherstate";
import Enteraccountdetails from "./component/Outerpage/Enteraccountdetails";
import Checkcontract from "./component/Outerpage/Checkcontract";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    try {
      window.scrollTo(0, 0);
    } catch (error) {
      console.warn("ScrollToTop failed:", error);
    }
  }, [pathname]);

  return null;
}
function App() {
  const [auth, setAuth] = useState(true);
  const [showauth, setShowauth] = useState(true);
  const [userId, setUserId] = useState("");
  const [email, setEmail] = useState("");
  

 
  // ✅ Watch token on mount and when it changes
  const refreshAuth = () => {
    const token = localStorage.getItem("token");
    if (token && typeof token === "string") {
      try {
        const decoded = jwtDecode(token);
        setUserId(decoded?.id || decoded?._id || null);
       setEmail(decoded?.email);
      } catch (err) {
      
        localStorage.removeItem("token");
        setUserId(null);
      }
    } else {
      setUserId(null);
    }
  };
 
  useEffect(() => {
    refreshAuth();
  }, []);

  // Render routes only when email is known
// if (email === null) {
//   return <p className="text-center mt-6">Loading...</p>;
// }

  const Showsigin = () => {
    setAuth(true);
    setShowauth(false);
  };

  const Showsignup = () => {
    setAuth(false);
    setShowauth(false);
  };

  return (
    <BrowserRouter>
    <ScrollToTop />
      <Header
        auth={auth}
        setAuth={setAuth}
        showauth={showauth}
        setShowauth={setShowauth}
        setUserId = {setUserId}
        setEmail = {setEmail}
        refreshAuth={refreshAuth} // 👈 pass refresh to Header
      />
      <Routes>
        {/* Public landing */}
        <Route
          path="/"
          element={
            userId ? (
              <Dashboard />
            ) : (
              <Home
                auth={auth}
                setAuth={setAuth}
                showauth={showauth}
                setShowauth={setShowauth}
              />
            )
          }
        />

        <Route path="/about" element={<About />} />
        <Route
          path="/dashboard"
          element={userId ? <Dashboard /> : <Navigate to="/" replace />}
        />
        <Route path="/contactUs" element={<Contactus />} />
        <Route path="/level" element={<Levels />} />
             <Route path="/terms&condition" element={<Termsandcondition />} />
                  <Route path="/privatepolicy" element={<Privacypolicy />} />
                        <Route path="/faq" element={<FAQ />} />
        <Route path="/level-seller" element={<SellerLevels />} />
        <Route path="/level-riders" element={<RiderLevels />} />
 <Route path="/create-contract" element={<Cotract />} /> 
 <Route path="/calive" element={<CongratContract/>} />  
 <Route path="/reviewcontract/:id" element={<Reviewcontract/>} /> 
 <Route path="/viewcontract/:id" element={<Mycontract/>} /> 
  <Route path="/statecontract" element={<Statecontract/>} /> 
    <Route path="/contract/status" element={<Otherstate/>} /> 
     <Route path="/contractpayment/:id" element={<Enteraccountdetails/>} /> 
  <Route path="/othercontract/:id" element={<Othercontract/>} /> 
  <Route path="/contract-payment" element={<Contractpayment/>} /> 
    <Route path="/check-contract" element={<Checkcontract/>} /> 
   
        <Route
          path="/orders"
          element={userId ? <OrdersPage /> : <Navigate to="/" replace />}
        />
        <Route
          path="/connect"
          element={<Connect /> }
        />
        <Route
          path="/connect-product"
          element={<ConnectProduct /> }
        />
         <Route
          path="/connect-rider"
          element={ <Connectrider /> }
        />
      <Route
          path="/congratulation"
          element={ <Congratulationpage /> }
        />
  <Route
          path="/sell-product"
          element={ <Sellproduct /> }
        />

          <Route
          path="/edit-product/:id"
          element={ <Editproduct /> }
        />

          <Route
          path="/bookmarkpage"
          element={ <Bookmarkpage /> }
        />
    
        <Route path="/generate-reset" element={<GenerateCodePage />} />
               <Route path="/feedback" element={<Feedback />} />
        <Route path="/reset" element={<VerifyAndResetPage />} />
        <Route path="/confirm-email" element={<OTP refreshAuth={refreshAuth} />} />

        <Route
          path="/edit-profile"
          element={userId ? <Editpage /> : <Navigate to="/" replace />}
        />
        <Route
          path="/create-order"
          element={userId ? <Createaorderpage /> : <Navigate to="/" replace />}
        />
        <Route
          path="/shop/:id"
          element={ <Viewshop /> }
        />
          <Route
          path="/ridershop/:id"
          element={ <Viewshoprider /> }
        />
        <Route
          path="/profile"
          element={userId ? <Profile refreshAuth={refreshAuth} /> : <Navigate to="/" replace />}
        />

        {/* 🔒 Protected */}  
        <Route
          path="/complete-profile"
          element={<CompleteProfile  refreshAuth={refreshAuth}  /> }
        />
        
  <Route
          path="/complete-rider-page"
          element={<CompleteRiderpage  refreshAuth={refreshAuth}  /> }
        />

          <Route
          path="/sellproduct"
          element={<ProductSellPage /> }
        />

        <Route
          path="/complete-profile-seller"
          element={<CompleteprofileSeller  refreshAuth={refreshAuth}  />}
        />
        <Route
          path="/confirm-payments"
          element={userId ? <PaymentPage /> : <Navigate to="/" replace />}
        />
        <Route
          path="/auth"
          element={<Auth setAuth={setAuth} auth={auth} refreshAuth={refreshAuth} />}
        />
    <Route
          path="/select"
          element={ <Select /> }
        />
          <Route
          path="/view-product/:id"
          element={<Viewproduct /> }
        />
          <Route
          path="/select-product"
          element={ <Sellerproductpage /> }
        />
        <Route
          path="/orders-seller"
          element={userId ? <Sellersorder /> : <Navigate to="/" replace />}
        />
        <Route
          path="/orders-rider"
          element={userId ? <Ridersorder /> : <Navigate to="/" replace />}
        />
        <Route
          path="/track-order"
          element={userId ? <Trackorderpage /> : <Navigate to="/" replace />}
        />
        <Route
          path="/track-order/:id"
          element={userId ? <Innertrack /> : <Navigate to="/" replace />}
        />

        <Route
          path="/balancepage/:id"
          element={userId ? <Balancepage /> : <Navigate to="/" replace />}
        />
        <Route
          path="/fundwallet"
          element={userId ? <Fundwallet /> : <Navigate to="/" replace />}
        />
       
        <Route
          path="/withdraw"
          element={userId ? <Withdrawpage /> : <Navigate to="/" replace />}
        />
        <Route
          path="/confirm"
          element={userId ? <Confirmationpage /> : <Navigate to="/" replace />}
        />
        <Route
          path="/historypage"
          element={userId ? <Historypage /> : <Navigate to="/" replace />}
        />
        <Route
          path="/addbankdetails"
          element={userId ? <Addbankdetails /> : <Navigate to="/" replace />}
        />
        <Route
          path="/notification"
          element={userId ? <Notification /> : <Navigate to="/" replace />}
        />

        <Route
          path="/profile-seller"
          element={userId ? <Sellerprofile  refreshAuth = {refreshAuth} /> : <Navigate to="/" replace />}
        />
        <Route
          path="/profile-seller-edit"
          element={userId ? <Sellereditprofile /> : <Navigate to="/" replace />}
        />
        <Route
          path="/view-review/:id"
          element={userId ? <Viewreviwspage /> : <Navigate to="/" replace />}
        />

        {/* Admin routes */}
        <Route
          path="/admindashboard"
          element={email === "support@ourasap.com" ? <Admindashboard /> : <Navigate to="/" replace />}
        />
        <Route
          path="/adminallusers"
          element={email === "support@ourasap.com" ? <Adminalluser /> : <Navigate to="/" replace />}
        />
        <Route
          path="/adminorders"
          element={email === "support@ourasap.com" ? <Adminorders /> : <Navigate to="/" replace />}
        />
        <Route
          path="/adminpayment"
          element={email === "support@ourasap.com" ? <AdminPayments /> : <Navigate to="/" replace />}
        />
        <Route
          path="/adminnotification"
          element={email === "support@ourasap.com" ? <Adminnoti /> : <Navigate to="/" replace />}
        />
         <Route
          path="/adminmessages"
          element={email === "support@ourasap.com" ? <Adminmessages /> : <Navigate to="/" replace />}
        />

           <Route
          path="/adminrider"
          element={email === "support@ourasap.com" ? <Adminrider /> : <Navigate to="/" replace />}
        />

        {/* Fallback */}
        <Route path="*" element={<Nopagefound />} />

        <Route
          path="/conversations"
          element={userId ? <Conversation /> : <Navigate to="/" replace />}
        />
        <Route
          path="/chat/:conversationId"
          element={userId ? <Messenger /> : <Navigate to="/" replace />}
        />
          <Route
          path="/perks"
          element={<Charegpage /> }
        />
           <Route
          path="/settings"
          element={<Settings  refreshAuth={refreshAuth}  /> }
        />
           <Route
          path="/blocked-users"
          element={<Blockeduser /> }
        />
           <Route
          path="/blocked-products"
          element={<Blockedproduct /> }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
